import React from 'react'

const MultiCarrierIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 16.933 16.933"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#ff9751"
                        d="M8.3.588 6.979 1.644a.265.265 0 0 0 .083.46l.613.203V6.35c0 .146.117.265.264.265h1.058c.147 0 .264-.12.264-.265V2.307l.613-.203a.265.265 0 0 0 .082-.46L8.633.588a.265.265 0 0 0-.332 0z"
                        opacity={1}
                        data-original="#ff9751"
                    />
                    <path
                        fill="#e4eff8"
                        d="M12.961 1.323a.265.265 0 0 0-.25.182l-.203.613-.34-.002a2.125 2.125 0 0 0-2.115 2.117v2.104c0 .146.118.265.264.265h1.058a.265.265 0 0 0 .266-.265V4.233c0-.313.215-.53.527-.53h.34l.203.614c.066.2.328.248.46.082l1.058-1.322a.265.265 0 0 0 0-.332L13.17 1.423a.265.265 0 0 0-.209-.1z"
                        opacity={1}
                        data-original="#e4eff8"
                        className="hovered-path"
                    />
                    <path
                        fill="#c4dcf0"
                        d="m13.17 4.4 1.059-1.323a.265.265 0 0 0 0-.332L13.17 1.423a.264.264 0 0 0-.459.082l-.002.004.99 1.236a.265.265 0 0 1 0 .332l-.989 1.238c.067.203.33.25.46.084zm-1.531-.696a.503.503 0 0 0-.527.53v2.103a.265.265 0 0 1-.266.265h.53a.265.265 0 0 0 .265-.265V4.233c0-.248.136-.433.347-.5l-.009-.03z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <path
                        fill="#549ad4"
                        d="M3.763 1.423 2.704 2.745a.265.265 0 0 0 0 .332L3.763 4.4a.265.265 0 0 0 .457-.083l.205-.613h.34c.312 0 .527.216.527.53v2.103c0 .147.119.266.266.265h1.058c.146 0 .264-.119.264-.265V4.234a2.125 2.125 0 0 0-2.115-2.118l-.34.002-.205-.613a.265.265 0 0 0-.457-.082z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#3588cb"
                        d="m3.763 1.423-.07.087.203.608.34-.002c1.161 0 2.115.956 2.115 2.118v2.103a.265.265 0 0 1-.264.265h.53c.145 0 .263-.12.263-.265V4.234a2.125 2.125 0 0 0-2.115-2.118l-.34.002-.205-.613a.265.265 0 0 0-.457-.082zM3.896 3.704l-.204.608.07.088a.265.265 0 0 0 .458-.083l.195-.584a.59.59 0 0 0-.18-.03z"
                        opacity={1}
                        data-original="#3588cb"
                    />
                    <path
                        fill="#ff7f29"
                        d="m8.3.588-.098.079 1.224.977c.166.131.119.394-.082.46l-.613.203V6.35a.265.265 0 0 1-.264.265h.53c.145 0 .263-.12.263-.265V2.307l.613-.203a.265.265 0 0 0 .082-.46L8.633.588a.265.265 0 0 0-.332 0z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#e4eff8"
                        d="M7.408 7.938a.265.265 0 0 0-.263.265v2.644a.265.265 0 0 0 .382.237l.94-.47.94.47a.265.265 0 0 0 .382-.237V8.203a.265.265 0 0 0-.263-.265z"
                        opacity={1}
                        data-original="#e4eff8"
                        className="hovered-path"
                    />
                    <path
                        fill="#ff9751"
                        d="M4.563 6.178 2.974 8.03a.265.265 0 0 0 .202.437h10.582a.265.265 0 0 0 .2-.437l-1.587-1.852a.265.265 0 0 0-.201-.092H4.736a.265.265 0 0 0-.173.092z"
                        opacity={1}
                        data-original="#ff9751"
                    />
                    <path
                        fill="#ff7f29"
                        d="M11.64 6.086c.078 0 .152.033.202.092L13.43 8.03h.529L12.37 6.178a.265.265 0 0 0-.201-.092zM3.177 8.202l.201.173.148-.173z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#e4eff8"
                        d="m7.663 6.086-.517 2.078c-.023.16.1.303.262.303h2.118a.265.265 0 0 0 .261-.303L9.27 6.086z"
                        opacity={1}
                        data-original="#e4eff8"
                        className="hovered-path"
                    />
                    <path
                        fill="#ff7f29"
                        d="M13.484 7.477a.265.265 0 0 1-.255.196H3.28l-.306.357a.265.265 0 0 0 .202.437h10.582a.265.265 0 0 0 .2-.437z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#ff9751"
                        d="M3.176 7.938a.265.265 0 0 0-.266.263v7.938a.265.265 0 0 0 .266.265h10.582a.265.265 0 0 0 .265-.265V8.2a.265.265 0 0 0-.265-.263z"
                        opacity={1}
                        data-original="#ff9751"
                    />
                    <path
                        fill="#c4dcf0"
                        d="m7.268 7.673-.122.49c-.023.16.1.304.262.304h2.118a.265.265 0 0 0 .261-.303l-.122-.491z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <path
                        fill="#e4eff8"
                        d="M7.408 7.938a.265.265 0 0 0-.263.265v2.644a.265.265 0 0 0 .382.237l.94-.47.94.47a.265.265 0 0 0 .382-.237V8.203a.265.265 0 0 0-.263-.265z"
                        opacity={1}
                        data-original="#e4eff8"
                        className="hovered-path"
                    />
                    <path
                        fill="#c4dcf0"
                        d="M8.996 7.938c.146 0 .264.119.264.265v2.644c0 .051-.015.1-.042.143l.188.094a.265.265 0 0 0 .383-.237V8.203a.265.265 0 0 0-.264-.265z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <path
                        fill="#c4dcf0"
                        d="m8.467 10.084-.94.47a.265.265 0 0 1-.382-.236v.53a.265.265 0 0 0 .382.236l.94-.47.94.47a.265.265 0 0 0 .382-.237v-.52a.265.265 0 0 1-.383.228z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <path
                        fill="#ff7f29"
                        d="M4.495 12.96a.265.265 0 0 0-.26.268v1.324a.265.265 0 1 0 .53 0v-1.324a.265.265 0 0 0-.27-.268z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#e4eff8"
                        d="M4.758 12.96a.265.265 0 0 0-.26.268v1.324c-.001.354.53.354.53 0v-1.324a.265.265 0 0 0-.27-.268z"
                        opacity={1}
                        data-original="#e4eff8"
                        className="hovered-path"
                    />
                    <path
                        fill="#ff7f29"
                        d="M5.553 12.96a.265.265 0 0 0-.26.268v1.324a.265.265 0 1 0 .53 0v-1.324a.265.265 0 0 0-.27-.268z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#e4eff8"
                        d="M5.816 12.96a.265.265 0 0 0-.26.268v1.324c0 .354.53.354.53 0v-1.324a.265.265 0 0 0-.27-.268z"
                        opacity={1}
                        data-original="#e4eff8"
                        className="hovered-path"
                    />
                    <path
                        fill="#ff7f29"
                        d="M6.611 12.96a.265.265 0 0 0-.26.268v1.324a.265.265 0 1 0 .53 0v-1.324a.265.265 0 0 0-.27-.268z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#e4eff8"
                        d="M6.874 12.96a.265.265 0 0 0-.26.268v1.324c0 .353.53.353.53 0v-1.324a.265.265 0 0 0-.27-.268z"
                        opacity={1}
                        data-original="#e4eff8"
                        className="hovered-path"
                    />
                    <path
                        fill="#ff7f29"
                        d="M13.494 7.938v7.671a.265.265 0 0 1-.265.266H2.909v.264a.265.265 0 0 0 .267.265h10.582a.265.265 0 0 0 .265-.265V8.2a.265.265 0 0 0-.265-.263z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#c4dcf0"
                        d="m8.741 6.086.46 1.85h.53l-.46-1.85z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                </g>
            </svg>

        </>
    )
}

export default MultiCarrierIcon